import { useSelector } from 'react-redux';
import Home from '../Pages/Home';
import './App.css';
import RiseLoader from "react-spinners/RiseLoader";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { useEffect } from 'react';
import { CAPTCHA_SITE_KEY } from '../Constants';



function App() {
  const Loading = useSelector(state => state.auth.isLoading);

  useEffect(() => {
    ReactRecaptcha3.init(CAPTCHA_SITE_KEY).then(
      (status) => {
        console.log(status);
      }
    );
  }, [])
  return (
  <div className="App">
   {Loading === true && <div className='LoaderWrapper'>
      <RiseLoader
          color={"#36d7b7"}
          loading={true}
          size={20}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
    </div> 
    }
    
      <Home />
    </div>
  );
  }
export default App;
 